import Vue from "./../vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import user from "@/store/modules/user";
import auth from "@/store/modules/auth";
import global from "@/store/modules/global";
import { UploaderStore } from "@xsenscloud/xse-styleguide";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    global,
    user,
    auth,
    uploader: UploaderStore
  },
  plugins: [new VuexPersistence({ modules: ["user", "auth"] }).plugin]
});
export default store;
